import { createAction, props } from '@ngrx/store';

import {
  EvseOverviewResponseStoreModel,
  EvseOverviewWebsocketMessageStoreModel,
  VehicleOverviewResponseStoreModel,
  VehicleOverviewWebsocketMessageStoreModel,
} from '@domain/single-site/single-site.models';

export const initializeSingleSite = createAction('[Single site] initialize');
export const setAssetDetailsDialogWide = createAction('[Single site] set asset details dialog wide', props<{ wide: boolean }>());

export const loadEvseOverview = createAction('[Single site] load evse overview');
export const loadEvseOverviewSuccess = createAction(
  '[Single site] load evse overview success',
  props<{ evseOverview: EvseOverviewResponseStoreModel }>()
);
export const loadEvseOverviewFailure = createAction('[Single site] load evse overview failure', props<{ error: string }>());
export const evseOverviewSocketMessageArrive = createAction(
  '[Single site] evse overview socket message arrive',
  props<{ message: EvseOverviewWebsocketMessageStoreModel }>()
);

export const loadVehicleOverview = createAction('[Single site] load vehicle overview');
export const loadVehicleOverviewSuccess = createAction(
  '[Single site] load vehicle overview success',
  props<{ vehicleOverview: VehicleOverviewResponseStoreModel }>()
);
export const loadVehicleOverviewFailure = createAction('[Single site] load vehicle overview failure', props<{ error: string }>());
export const vehicleOverviewSocketMessageArrive = createAction(
  '[Single site] vehicle overview socket message arrive',
  props<{ message: VehicleOverviewWebsocketMessageStoreModel }>()
);

export const clearSingleSiteData = createAction('[Single site] clear single site data');
